export default function CameraIcon( { classes, color="rgba(255,255,255,0.7)" }){
    return (
        <svg
            width={514}
            height={514}
            viewBox="0 0 514 514"
            xmlns="http://www.w3.org/2000/svg"
            className={"ghost-icon " + classes}
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
            imageRendering="optimizeQuality"
            fillRule="evenodd"
            clipRule="evenodd"
        >
        <g fill={color}>
        <path d="M189.953 0h181.91c14.127 0 20.464 12.563 25.685 25.685l19.328 48.584h33.657c33.807 0 61.467 27.662 61.467 61.467V330.27c0 33.805-27.662 61.467-61.467 61.467H61.467C27.662 391.737 0 364.077 0 330.27V135.736c0-33.807 27.66-61.467 61.467-61.467h81.057l21.744-48.584C170.039 12.79 175.826 0 189.953 0zm76.731 144.185c41.11 0 74.475 33.364 74.475 74.476 0 41.11-33.363 74.475-74.475 74.475-41.11 0-74.475-33.363-74.475-74.475.001-41.112 33.365-74.476 74.475-74.476zM442.75 115.57c13.577 0 24.573 10.996 24.573 24.574 0 13.578-10.996 24.574-24.573 24.574-13.579 0-24.575-10.996-24.575-24.574.041-13.578 11.038-24.574 24.575-24.574zM266.684 95.703c67.936 0 122.999 55.064 122.999 122.999 0 67.893-55.065 122.999-122.999 122.999-67.894 0-122.999-55.106-122.999-122.999.041-67.935 55.105-122.999 122.999-122.999z"/>
        </g>
  </svg>
    )
}